module.exports = __webpack_public_path__ + "static/media/Tomato-prices-are-up-by-over-80-in-these-Lagos-810x507.3fcbee36.jpg";